import { render } from "./WhatsAnApi.vue?vue&type=template&id=d43c5640"
import script from "./WhatsAnApi.vue?vue&type=script&lang=js"
export * from "./WhatsAnApi.vue?vue&type=script&lang=js"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__